// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgStarFullIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M12 2a1 1 0 0 1 .918.604l2.411 5.593 5.788.684a1 1 0 0 1 .575 1.715l-4.333 4.159 1.182 6.054a1 1 0 0 1-1.495 1.05L12 18.84l-5.046 3.017a1 1 0 0 1-1.495-1.05l1.18-6.053-4.331-4.16a1.001 1.001 0 0 1 .575-1.714l5.787-.684 2.412-5.593.068-.131A1 1 0 0 1 12 2" />
  </g>
);
export default SvgStarFullIcon;
SvgStarFullIcon.displayName = 'SvgStarFullIcon';
